import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { primeTelemetry } from './flow/telemetry';
import './i18n';
import './theme.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('#root element not found');
}

// Before the first step renders, so its pace and the page's vitals count from load.
primeTelemetry();

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
